<template lang="html">
    <div class="">
      <div class="Sumitted_Hidden" v-show="!Sumitted">


        <header>
            <div class="headerTitle">
                <h1 style="font-weight: 100;">
                    <el-button-group>
                        <router-link to="/">
                      <el-button type="primary" icon="el-icon-back"></el-button>
                    </router-link>
                    </el-button-group>
                    请填写相关信息
                </h1>

            <el-steps  :active="1" finish-status="success" align-center >
              <el-step title="选模板" icon="el-icon-picture"></el-step>
              <el-step title="填信息" icon="el-icon-edit"></el-step>
              <el-step title="上传" icon="el-icon-upload"></el-step>
            </el-steps>
            </div>
        </header>


        <section class="WriteinfoPanel" v-show="hasShopName||hasWifi">
          <p class="section_title"><i class="el-icon-edit"></i>模板信息</p>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">


            <el-form-item label="店铺名称" prop="ShopName" placeholder="" v-if="hasShopName">
              <el-input  v-model="ruleForm.ShopName" @blur="getFontPreview"></el-input>
            </el-form-item>
            <el-form-item label="字体颜色" prop="ShopNameColor" placeholder="" v-if="this.$store.getters.get_Card_type.indexOf('color')>=0">
              <el-color-picker v-model="ruleForm.ShopNameColor" @change="getFontPreview"></el-color-picker>
            </el-form-item>

            <!-- <el-form-item label="二维码下方文字" prop="QrcodeDes" placeholder="" v-if="CardQrcodeCount==1" >
              <el-input v-model="ruleForm.QrcodeDes"></el-input>
            </el-form-item> -->

            <el-form-item label="店名字体" v-show="hasShopName">

            <el-cascader
                placeholder="请选择字体"
                @change="getFontPreview"
                v-show="hasShopName"
                v-model="ruleForm.FontType"
                :options="fontOptions"
                :show-all-levels="false"
              ></el-cascader>

              <img :src="fontPreviewDataURL" id="fontPreview"/>

            </el-form-item>



            <el-form-item label="WiFi账号" prop="wifiAccount" v-if="hasWifi" >
                <el-input v-model="ruleForm.wifiAccount" placeholder="中文8个字内,英文12个字内" @blur="getQrcodePreview"></el-input>
            </el-form-item>
            <el-form-item label="WiFi密码" prop="wifiPassword" v-if="hasWifi">
                <el-input v-model="ruleForm.wifiPassword" placeholder="长度建议小于14位" @blur="getQrcodePreview"></el-input>
            </el-form-item>

          </el-form>
        </section>



        <section class="WriteinfoPanel">
          <p class="section_title"><i class="el-icon-upload"></i>你需要上传<span class="hightlightText">{{CardQrcodeCount}}</span>个二维码<span v-show="isShowLoading" class="upload-Loading"><i class="el-icon-loading" style="font-size: 2em;"></i><p>智能识别中...</p></span></p>

          <el-upload
            ref="eleupload"
            list-type="picture-card"
            drag
            accept="image/jpeg,image/png"
            action="/api/uploadImgAndGetURL/"
            :auto-upload="true"
            :on-success="handlePictureSuccess"
            :on-error="handlePictureError"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            :file-list="fileList"
            multiple
            >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">仅支持jpg/png格式，且小于5MB的清晰图片</div>
          </el-upload>
            <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
          <el-dialog :visible.sync="dialogVisible" size="tiny">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </section>
      </div>

        <!-- <section class="WriteinfoPanel">
        <p class="section_title"><i class="el-icon-picture"></i>预览区域</p>
        <QrcodeCanvas_2 :QrcodeDes='ruleForm.QrcodeDes' :wifiAccount='ruleForm.wifiAccount' :wifiPassword='ruleForm.wifiPassword' :qrcodeUrl='qrcodeUrl' :QrcodeTitle='ruleForm.ShopName'  :ShopNameImgDataURL="ruleForm.ShopNameImgDataURL"ref="QrcodeCanvas"></QrcodeCanvas_2>

        </section> -->

         <section class="WriteinfoPanel">
        <p class="section_title"><i class="el-icon-picture"></i>预览模板：{{this.$store.getters.get_Card_type}} </p>
          <img class="card-img" :src='qrcodePreviewDataURL' :alt="this.$store.getters.get_Card_type+'型号模板'">

        </section>

        <section class="WriteinfoPanel">
          <p class="section_title"><i class="el-icon-info"></i>买家信息</p>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
          <el-form-item label="旺旺名称" prop="WangWangID">
              <el-input v-model="ruleForm.WangWangID"></el-input>
          </el-form-item>
          </el-form>
          <Button class="submit_btn" @click='submitQrcode' :disabled="this.ruleForm.WangWangID.trim()==''" v-bind:class="{'submit_btn_disabled':!this.ruleForm.WangWangID.trim()!=''}">
            完成
          </Button>
        </section>


        <section class="WriteinfoPanel">
          <p class="section_title"><i class="el-icon-star-on"></i>客户须知</p>
          <ul class="userTips">

            <li>为了防止出现错漏，提交后请<span class="hightlightText">注意跟客服进行确认</span>。</li>
            <li>诚信木匠提供服务</li>
          </ul>
        </section>

    </div>
</template>

<script>
import axios from "axios";
import FontOptions from "@/store/fontOptions";
import swal from "sweetalert";
export default {
  data() {
    return {
      fontOptions: FontOptions,
      qrcodeUrl: {
        wechatPay: "",
        wechatFriend: "",
        AliPay: "",
        officialAccount: "",
        SpecialOne: "",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      Sumitted: false,
      isShowLoading: false,
      completeFill: true,
      isShowSelectLoading: false,

      ruleForm: {
        ShopName: "",
        ShopNameColor: "#000",
        wifiAccount: "",
        wifiPassword: "",
        FontType: [],
        ShopPhone: "",
        WangWangID: "",
        QrcodeDes: "",
        ShopNameImgDataURL: "",
      },
      qrcodePreviewDataURL:
        this.$store.getters.get_ossURL +
        "/whiteNoQrcode/" +
        this.$store.getters.get_Card_type +
        ".png/middle-thumbnail",
      fontPreviewDataURL: "",

      rules: {
        ShopName: [
          { required: true, message: "请输入店铺名称", trigger: "blur" },
          {
            min: 1,
            max: 12,
            message: "长度在十五个中文字以内",
            trigger: "blur",
          },
        ],
        FontType: [
          { required: false, message: "请选择字体", trigger: "change" },
        ],
        ShopPhone: [
          { required: false, message: "请填写联系电话", trigger: "blur" },
        ],
        WangWangID: [
          { required: true, message: "请填写你的旺旺ID", trigger: "blur" },
        ],
        wifiAccount: [
          { required: true, message: "请填写WiFi账号", trigger: "blur" },
        ],
        wifiPassword: [
          { required: true, message: "请填写WiFi密码", trigger: "blur" },
        ],
        QrcodeDes: [
          {
            required: true,
            message: "请填写二维码下方描述文字",
            trigger: "blur",
          },
        ],
      },
      resultForm: {
        wechatPayURL: "",
        aliPayURL: "",
        wechatFriendURL: "",
        wechatOfficialURL: "",
      },
    };
  },
  mounted: function () {
    //滚动条回到顶部
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    //获取当前模板类型
    if (this.$store.getters.get_Card_type == "") {
      // this.$message.info('刷新后 请重新选择模板');
      this.$router.push("/");
      // this.clearCookies();
    }
  },
  computed: {
    hasShopName: function () {
      return this.$store.getters.get_hasShopName;
    },
    hasWifi: function () {
      return this.$store.getters.get_hasWifi;
    },
    CardQrcodeCount: function () {
      return this.$store.getters.get_CardQrcodeCount;
    },
    Card_Type: function () {
      return this.$store.getters.get_Card_type;
    },
    Card_ImgPath: function () {
      return "./static/preview/" + this.$store.getters.get_Card_type + ".jpg";
    },
    getTemplateOpts() {
      return {
        templateType: "t-" + this.$store.getters.get_Card_type,
        fontType: this.ruleForm.FontType[this.ruleForm.FontType.length - 1],
        shopName: this.ruleForm.ShopName,
        ShopNameColor: this.ruleForm.ShopNameColor,
        WangWangID: this.ruleForm.WangWangID,
        WifiName: this.ruleForm.wifiAccount,
        WifiPwd: this.ruleForm.wifiPassword,

        wechatPayURL: this.resultForm.wechatPayURL,
        aliPayURL: this.resultForm.aliPayURL,
        wechatFriendURL: this.resultForm.wechatFriendURL,
        wechatOfficialURL: this.resultForm.wechatOfficialURL,
      };
    },
  },

  methods: {
    clearResultForm() {
      for (let attr in this.resultForm) {
        this.resultForm[attr] = "";
      }
      console.log(`this.resultForm:${this.resultForm}`);
    },
    submitUpload() {
      this.$refs.eleupload.submit();
    },
    getFontPreview() {
      let that = this;
      console.log(this.ruleForm.ShopName);
      axios
        .post("/api/fontPreview/", {
          shopName: that.ruleForm.ShopName,
          ShopNameColor: that.ruleForm.ShopNameColor,
          fontType: that.ruleForm.FontType[this.ruleForm.FontType.length - 1],
        })
        .then((res) => {
          that.fontPreviewDataURL = res.data;
        });
      this.getQrcodePreview();
    },
    getQrcodePreview() {
      axios.post("/api/qrcodePreview/", this.getTemplateOpts).then((res) => {
        console.log(res);
        this.qrcodePreviewDataURL = res.data;
      });
    },

    handleRemove(file, fileList) {
      this.$refs.eleupload.clearFiles();
      this.clearResultForm();
      this.getQrcodePreview();
      this.isShowLoading = false;
    },

    getCookie(name) {
      var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      else return null;
    },
    submitQrcode() {
      let that = this;
      if (this.isShowLoading) {
        swal({
          title: "二维码尚未完成识别",
          text: "请稍后再试,或重新上传",
          type: "info",
        });
        return false;
      }
      swal({
        title: "要提交吗?",
        text: "请检查填写信息是否完整，提交完成后和客服确认",
        type: "info",
        buttons: ["我再检查一下", "提交"],
        confirmButtonColor: "#13ce66",
        cancelButtonText: "",
        closeOnConfirm: false,
        showLoaderOnConfirm: true,
      }).then((value) => {
        if (!value) {
          return;
        }

        that.UploadPicAndInfo();
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    UploadPicAndInfo() {
      axios
        .post("/api/generateQrcode/convert/", this.getTemplateOpts)
        .then((res) => {
          console.log(res);
          swal("提交成功", "谢谢你的光临", "success");
          this.clearResultForm();
        })
        .then(() => {
          this.getQrcodePreview();
        });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureError(err, file, fileList) {
      console.log(err);
      this.$message.error("图片上传失败");
      this.isShowLoading = false;
    },
    setResultForm(key, value) {
      this.resultForm[key] = value;
    },
    saveResult(qrcodeURL) {
      let CheckqrcodeURL = qrcodeURL.toLowerCase();
      let isWechatPayURL =
        CheckqrcodeURL.indexOf("wxp://") >= 0 ||
        CheckqrcodeURL.indexOf("payapp.weixin") >= 0 ||
        CheckqrcodeURL.indexOf("wx.tenpay") >= 0;

      if (CheckqrcodeURL.indexOf("alipay") >= 0) {
        this.setResultForm("aliPayURL", qrcodeURL);
      }
      //微信支付
      else if (isWechatPayURL) {
        this.setResultForm("wechatPayURL", qrcodeURL);
      }
      //微信加好友
      else if (CheckqrcodeURL.indexOf("u.wechat") >= 0) {
        this.setResultForm("wechatFriendURL", qrcodeURL);
      }
      //微信公众号
      else if (CheckqrcodeURL.indexOf("weixin.qq") >= 0) {
        this.setResultForm("wechatOfficialURL", qrcodeURL);
      }
    },
    handlePictureSuccess(res, file, fileList) {
      console.log(res);
      if (res.status == 1) {
        this.$message.success(res.msg);
        this.saveResult(res.note);
      } else {
        this.$message.error(res.msg);
        this.$refs.eleupload.clearFiles();
        this.clearResultForm();
      }
      this.getQrcodePreview();
      this.isShowLoading = false;
    },

    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      this.isShowLoading = true;

      if (!(isJPG || isPNG)) {
        this.$message.error("上传的图片只能是 JPG 或 PNG 格式!");
        this.isShowLoading = false;
      }
      if (!isLt5M) {
        this.$message.error("上传的单张图片大小不能超过 5MB!");
        this.isShowLoading = false;
      }
      return (isJPG || isPNG) && isLt5M;
    },
    toggleShowLoading() {
      this.isShowLoading = !this.isShowLoading;
    },
  },
};
</script>

<style lang="stylus">
@import '../assets/color.styl';

#fontPreview {
  max-width: 100%;
  display: block;
  margin: 20px auto;
}

.headerTitle {
  background: color_light;
  color: color_Main;
  padding: 0.5em;
}

h1 span {
  float: left;
}

.submit_btn {
  width: 100%;
  color: color_light;
  background: color_highlight;
  border: none;
  padding: 1em;
  font-size: 1em;
  cursor: pointer;
  border-radius: 4px;
}

.submit_btn_disabled {
  background: color_disabled !important;
}

h1 .el-button {
  border: none;
  color: color_Main;
  background: color_light;
  font-size: 0.8em;
}

h1 .el-button-group {
  float: left;
}

.section_title {
  color: #899db5;
  font-size: 1.2em;
  margin: 0 0 1em 0;
  text-align: left;
}

.WriteinfoPanel {
  margin: 1em 1em;
  padding: 1em;
  box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.09);
  border: 1px solid #ededed;
  border-radius: 5px;
}

p [class^=el-icon-] {
  margin-right: 0.5em;
}

.userTips {
  text-align: left;
  list-style: none;
  padding-left: 3px;

  li::before {
    content: '■';
    margin-right: 1em;
    line-height: 3em;
    color: color_highlight;
  }
}

.upload-Loading {
  position: relative;
  top: 12px;
  display: block;
  text-align: center;
  line-height: 32px;
}

.upload-Loading p {
  font-size: 12px;
  margin: 0;
  display: block;
}

.hightlightText {
  margin: 7px;
  padding: 2px 10px;
  color: #13ce66;
  background: #fbfdff;
  border: 1px dashed #899db5;
  border-radius: 5px;
}

.quote {
  color: color_Sub;
  text-align: right;
}

.el-color-picker__trigger {
  min-width: 150px;
}

.el-upload-dragger {
  width: auto !important;
  height: auto !important;
  border: none !important;
}

.WriteinfoPanel .card-img {
  box-shadow: 1px 1px 9px 2px #0000002b;
  border: 1px solid #cacaca;
  border-radius: 5px;
  width: 100%;
  max-width: 625px;
  height: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// WriteInfo.vue?5fbb5849